// Planted defects for the camera, beside what they break: a game's camera checks turn each on to prove they can fail
// (engine/docs/research/suggestions/harness-qa-and-agent-workflow.md, planted-defect oracles). All off in play.

/** The camera's planted defects. One shared record: the rig reads it every frame. */
export const CAMERA_FAULTS = {
  /** The arm eases out as fast as it pulls in (rig.ts): a pull-in-faster-than-ease-out check must fail. */
  equalArmRates: false,
  /** The camera is stepped with the sim (rig.ts): it reads the newest step's pose and moves only on frames that took a
   *  step, by the steps' sim time, instead of the pose interpolated at the frame's alpha. A jitter check at a frame rate
   *  that isn't a multiple of the step rate (144 Hz on a 120 Hz sim) must fail. */
  steppedWithSim: false,
  /** The arm ignores the collision world (arm.ts): a camera-inside-a-collider check must fail. */
  noCollision: false,
  /** Thin colliders count as solid (arm.ts): a thin-collider check (and a one-frame arm jump check) must fail. */
  thinAsSolid: false,
  /** Profile blends count frames at an assumed 60 Hz instead of the frame's real time (profiles.ts): a blend-time
   *  check at any other frame rate must fail. */
  blendCountsFrames: false,
};

/** A camera planted defect's name. */
export type CameraFaultName = keyof typeof CAMERA_FAULTS;
